import { axiosBaseQuery, request } from 'react-common'
import { createApi } from '@reduxjs/toolkit/query/react'
import { GroupActivityWorkflow } from '@/api/models/aggregate'
import { CollaborativeActivityParticipantQuery } from '@/api/models/collaborative'

export const collaborativeApi = createApi({
  reducerPath: 'collaborativeApi',
  baseQuery: axiosBaseQuery(request),
  endpoints: (builder) => ({
    queryCollaborativeActivityParticipants: builder.query<
      CollaborativeActivityParticipantQuery,
      { objectiveWorkflowId: string; activityPathId: string; loadOptions?: Record<string, any> }
    >({
      query: ({ objectiveWorkflowId, activityPathId, loadOptions }) => ({
        url: `users/me/objective-workflows/${objectiveWorkflowId}/activity-paths/${activityPathId}/participants/query`,
        method: 'get',
        params: { query: loadOptions },
      }),
    }),

    getGroupActivityWorkflows: builder.query<
      GroupActivityWorkflow,
      { objectiveWorkflowAggregateId: string; groupActivityWorkflowId: string }
    >({
      query: ({ objectiveWorkflowAggregateId, groupActivityWorkflowId }) => ({
        url: `users/me/objective-workflow-aggregates/${objectiveWorkflowAggregateId}/group-activity-workflows/${groupActivityWorkflowId}`,
        method: 'get',
      }),
    }),
  }),
})

export const {
  useQueryCollaborativeActivityParticipantsQuery,
  useGetGroupActivityWorkflowsQuery,
  useLazyGetGroupActivityWorkflowsQuery,
} = collaborativeApi
